import React, { useState, useEffect, useRef } from 'react';
import { Box, Typography, Grid, Container, Modal, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseRounded';
import Header from './Header';
import Footer from './Footer';

const Gallery = () => {
  const [images] = useState([
    'Images/Gallery/image1.png',
    'Images/Gallery/image2.png',
    'Images/Gallery/image3.png',
    'Images/Gallery/image4.png',
    'Images/Gallery/image5.png',
    'Images/Gallery/image6.png',
    'Images/Gallery/image7.png',
    'Images/Gallery/image8.png',
    'Images/Gallery/image9.png',
    'Images/Gallery/image10.png',
    'Images/Gallery/image11.png',
    'Images/Gallery/image12.png',
    'Images/Gallery/image13.png',
    'Images/Gallery/image15.jpg',
    'Images/Gallery/image14.png',
  ]);

  const [open, setOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);
  const [visibleImages, setVisibleImages] = useState([]);
  const containerRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const index = entry.target.dataset.index;
          if (entry.isIntersecting && !visibleImages.includes(index)) {
            setVisibleImages((prev) => [...prev, index]);
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = containerRef.current.querySelectorAll('[data-index]');
    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, [visibleImages]);

  const handleOpen = (image) => {
    setCurrentImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentImage(null);
  };

  return (
    <Box>
      <Header />
      <Box
        sx={{
          position: 'relative',
          width: '100%',
          height: { xs: '40vh', sm: '45vh', md: '50vh' },
          overflow: 'hidden',
        }}
      >
        <Box
          sx={{
            backgroundImage: `url('/Images/Gallery/header.png')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3))',
            zIndex: 2,
          }}
        />
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '5%',
            transform: 'translateY(-50%)',
            zIndex: 3,
            color: 'white',
            textAlign: 'left',
            maxWidth: '90%',
          }}
        >
          <Typography
            variant="h1"
            className="chalk-text"
            sx={{
              fontWeight: 'bold',
              fontSize: { xs: '5rem', sm: '5rem', md: '10rem' },
              lineHeight: 1.2,
              marginBottom: { xs: '0.5rem', sm: '1rem' },
            }}
          >
            Gallery
          </Typography>
        </Box>
      </Box>
      <Container ref={containerRef} sx={{ py: 4 }}>
        <Grid container spacing={4}>
          {images.map((image, index) => (
            <Grid
              item
              xs={12}
              sm={6}
              md={4}
              key={index}
              data-index={index}
              style={{
                opacity: visibleImages.includes(String(index)) ? 1 : 0,
                transform: visibleImages.includes(String(index)) ? 'scale(1)' : 'scale(0.8)',
                transition: 'opacity 0.6s ease, transform 0.6s ease',
              }}
            >
              <Box
                sx={{
                  height: 200,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center',
                  borderRadius: 2,
                  boxShadow: 3,
                  cursor: 'pointer',
                  margin: '0 auto',
                  backgroundImage: `url(${image})`,
                  position: 'relative',
                  width: '100%',
                }}
                onClick={() => handleOpen(image)}
              >
                <img
                  src={image}
                  alt={`gallery-img-${index}`}
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    objectPosition: 'center',
                    borderRadius: '8px',
                  }}
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
      <Modal
        open={open}
        onClose={handleClose}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        }}
      >
        <Box
          sx={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
          }}
        >
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: '16px',
              right: '16px',
              backgroundColor: 'rgba(255, 255, 255, 0.8)',
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={currentImage}
            alt="Full Screen"
            style={{
              maxWidth: '90%',
              maxHeight: '90%',
              borderRadius: '8px',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.5)',
            }}
          />
        </Box>
      </Modal>
      <Footer />
    </Box>
  );
};

export default Gallery;
